import React from "react";
import { Dialog, DialogContent, Button } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/LogoutConfirmationDialog.css";

const LogoutConfirmationDialog = ({ open, onClose, onSave }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        className: "logout-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined className="logout-dialog-close" onClick={onClose} />
        <div className="logout-dialog-content">
          <div className="logout-dialog-title-container">
            <div className="logout-dialog-title">Do you want to logout?</div>
          </div>
          <Button variant="contained" color="send" onClick={onSave}>
            Yes
          </Button>
          <Button variant="contained" onClick={onClose} color="secondaryButton">
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmationDialog;
